var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNkeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.2,324.2V557h-42.5L196.4,410.5h-1.7V557h-49.2V324.2h43.2l100.5,146.4h2V324.2H340.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.2,557V324.2h49.2v102.6h3.1l83.8-102.6h59l-86.4,104.2L565.3,557h-58.9l-63.8-95.7l-24.2,29.5V557H369.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578.4,557V324.2h156.8v40.6H627.6v55.5h99.5v40.6h-99.5v55.6h108.1V557H578.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNkeIcon);
export default __webpack_public_path__ + "static/media/nke_icon.44078e0f6b24ed4f014882e5d096846a.svg";
export { ForwardRef as ReactComponent };